export default {"src":"/_next/static/media/icon_instagram.766eb30a.svg","height":200,"width":200};